import {
	Button,
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownTrigger,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
} from "@heroui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { RequestSchema, TDoctor, TRequest } from "@shared/entities";
import { useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppApi } from "src/appApi";
import { useModal } from "src/infra/ModalProvider/ModalContext";
import { useAdminStore } from "src/store/adminStore";

// attach doctor modal to request by admin
export function AttachDoctorModal({
	request,
	doctors = [],
	onSave,
}: {
	onSave?: (request?: Partial<TRequest>) => void;
	request: TRequest;
	doctors?: TDoctor[];
}) {
	const appApi = useAppApi();

	const adminStore = useAdminStore();
	console.log("adminStore", adminStore);

	const _doctors = adminStore.doctors ?? doctors;

	const modalApi = useModal();

	const { handleSubmit, control } = useForm<TRequest>({
		resolver: zodResolver(RequestSchema),
		defaultValues: request,
	});

	const { t } = useTranslation(["admin", "common"]);

	const _onSubmit = handleSubmit(
		async (data) => {
			// todo why run twice

			const response = await appApi.api.admin.setRequest({
				...data,
				status: "pending_doctor",
			});

			onSave?.(response.request);
			modalApi.close("");
		},
		(err) => {
			console.log("err", err);
		}
	);

	const ref = useRef<HTMLFormElement>(null);

	return (
		<ModalContent>
			{(onClose) => (
				<>
					<ModalHeader>שיוך לרופא</ModalHeader>
					<ModalBody className="py-0">
						<form onSubmit={_onSubmit} ref={ref}>
							<Controller
								control={control}
								name="doctor.id"
								render={({ field }) => {
									return (
										<Dropdown>
											<DropdownTrigger>
												<Button variant="bordered">{t("requests.attachDoctor")}</Button>
											</DropdownTrigger>
											<DropdownMenu
												aria-label="select doctor"
												selectedKeys={new Set([field.value])}
												selectionMode="single"
												onSelectionChange={(keys) => {
													const selectedValue = Array.from(keys)
														.join(", ")
														.replace(/_/g, "");
													field.onChange(selectedValue);
												}}
											>
												{_doctors.map((doctor) => {
													return (
														<DropdownItem
															textValue={doctor.id}
															onSelect={() => {}}
															key={doctor.id}
														>
															{doctor.firstName}
														</DropdownItem>
													);
												})}
											</DropdownMenu>
										</Dropdown>
									);
								}}
							/>
							<ModalFooter className="px-0">
								<Button type="button" variant="light" onPress={onClose}>
									ביטול
								</Button>
								<Button type="submit" color="primary">
									אישור
								</Button>
							</ModalFooter>
						</form>
					</ModalBody>
				</>
			)}
		</ModalContent>
	);
}
